module.exports = __webpack_public_path__ + "static/media/bg-pattern-top-desktop.0e1f3813.svg";